import { render, staticRenderFns } from "./SelectedFleet.vue?vue&type=template&id=b58ac3e2&scoped=true&"
import script from "./SelectedFleet.vue?vue&type=script&lang=js&"
export * from "./SelectedFleet.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFleet.vue?vue&type=style&index=0&id=b58ac3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58ac3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VList,VListItem,VSpacer,VSubheader})
